import React from 'react';
import Checkmarks from 'components/common/maps/checkmarks';
import { IMapLessonItemStates } from 'types';

const Art: React.FC<IMapLessonItemStates> = ({
  active,
  process,
  visited,
}: IMapLessonItemStates) => {
  return (
    <g
      className={
        active
          ? 'prefix__component-item animationComponent'
          : 'prefix__component-item'
      }
    >
      {active && (
        <g
          className={
            active
              ? 'prefix__active-process animation'
              : 'prefix__active-process'
          }
        >
          <image
            width={195}
            height={304}
            xlinkHref="data:image/png;base64,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"
          />
        </g>
      )}
      <g id="bbf1e871-a572-4ad6-a35b-a8c2ec4dec5b" data-name="art">
        <g>
          <polygon
            points="98.59 239.92 98.59 256.17 49.45 227.74 49.45 211.49 98.59 239.92"
            fill="#ee93a4"
          />
          <polygon
            points="49.45 211.49 98.59 239.92 147.94 211.49 98.59 183.06 49.45 211.49"
            fill="#c13e5a"
          />
          <polygon
            points="56.35 207.43 141.04 207.43 126.82 158.69 70.57 158.69 56.35 207.43"
            fill="#bc3350"
          />
          <polygon
            points="51.66 215.55 51.66 227.36 62.4 233.79 62.4 221.99 51.66 215.55"
            fill="#b0376b"
          />
          <polygon
            points="52.13 216.35 52.13 227.12 61.93 233 61.93 222.22 52.13 216.35"
            fill="#e2345c"
          />
          <polygon
            points="60.47 221.35 55.55 229.17 57.08 230.09 60.47 221.35"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="65.15 223.14 65.15 235.19 78.29 242.86 78.29 230.81 65.15 223.14"
            fill="#8a316d"
          />
          <polygon
            points="65.84 224.18 65.84 234.96 77.6 241.81 77.6 231.04 65.84 224.18"
            fill="#b0376b"
          />
          <polygon
            points="59.14 220.81 51.95 227.27 54.07 228.54 59.14 220.81"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="49.45 179 98.59 207.43 147.94 179 98.59 150.56 49.45 179"
            fill="#d73c58"
          />
          <polygon
            points="56.15 174.94 140.83 174.94 126.62 126.19 70.36 126.19 56.15 174.94"
            fill="#bc3350"
          />
          <polygon
            points="98.59 239.92 98.59 256.17 147.94 227.74 147.94 211.49 98.59 239.92"
            fill="#3d356f"
          />
          <polygon
            points="146.01 214.97 146.01 226.78 135.28 233.21 135.28 221.41 146.01 214.97"
            fill="#6d2b5a"
          />
          <polygon
            points="145.54 215.77 145.54 226.54 135.75 232.42 135.75 221.64 145.54 215.77"
            fill="#8a316d"
          />
          <polygon
            points="132.52 222.56 132.52 234.61 119.38 242.28 119.38 230.23 132.52 222.56"
            fill="#6d2b5a"
          />
          <polygon
            points="131.83 223.6 131.83 234.38 120.07 241.23 120.07 230.46 131.83 223.6"
            fill="#8a316d"
          />
          <polygon
            points="116.86 231.44 116.86 243.41 102.71 251.03 102.71 239.66 116.86 231.44"
            fill="#6d2b5a"
          />
          <polygon
            points="116.16 232.42 116.16 243.19 103.42 250.05 103.42 239.93 116.16 232.42"
            fill="#8a316d"
          />
          <polygon
            points="110.68 235.65 104.58 249.43 106.79 248.24 110.68 235.65"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="130.19 224.56 120.72 240.85 123.07 239.49 130.19 224.56"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="143.51 216.99 138.11 231 139.57 230.12 143.51 216.99"
            fill="#71aaa6"
            opacity="0.51"
          />
          <rect
            x="56.35"
            y="207.43"
            width="84.69"
            height="16.25"
            fill="#24438e"
          />
          <rect
            x="59.83"
            y="209.15"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="114.13"
            y="209.12"
            width="23.02"
            height="12.83"
            fill="#3d356f"
          />
          <rect
            x="86.98"
            y="209.15"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="60.89"
            y="209.75"
            width="20.89"
            height="11.64"
            fill="#cf82bc"
          />
          <rect
            x="88.04"
            y="209.72"
            width="20.89"
            height="11.64"
            fill="#a86c9d"
          />
          <rect
            x="115.2"
            y="209.75"
            width="20.89"
            height="11.64"
            fill="#718fa8"
          />
          <polygon
            points="70.36 209.75 62.09 221.39 63.79 221.39 70.36 209.75"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="126.82 209.75 118.55 221.39 120.25 221.39 126.82 209.75"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="74.36 209.75 65.46 221.36 67.7 221.36 74.36 209.75"
            fill="#f4bece"
          />
          <polygon
            points="131.59 209.76 122.68 221.37 124.93 221.37 131.59 209.76"
            fill="#f4bece"
            opacity="0.51"
          />
          <polygon
            points="98.59 207.43 98.59 223.68 49.45 195.24 49.45 179 98.59 207.43"
            fill="#ee93a4"
          />
          <polygon
            points="147.94 179 147.94 195.24 98.59 223.68 98.59 207.43 147.94 179"
            fill="#3d356f"
          />
          <polygon
            points="144.91 183.41 144.91 195.22 134.18 201.66 134.18 189.85 144.91 183.41"
            fill="#6d2b5a"
          />
          <polygon
            points="144.45 184.21 144.45 194.98 134.65 200.86 134.65 190.09 144.45 184.21"
            fill="#8a316d"
          />
          <polygon
            points="131.43 191 131.43 203.05 118.28 210.72 118.28 198.67 131.43 191"
            fill="#6d2b5a"
          />
          <polygon
            points="130.73 192.04 130.73 202.82 118.98 209.68 118.98 198.9 130.73 192.04"
            fill="#8a316d"
          />
          <polygon
            points="115.77 199.88 115.77 211.85 101.62 219.47 101.62 208.1 115.77 199.88"
            fill="#6d2b5a"
          />
          <polygon
            points="115.06 200.86 115.06 211.63 102.33 218.49 102.33 208.37 115.06 200.86"
            fill="#8a316d"
          />
          <polygon
            points="109.58 204.09 103.49 217.87 105.7 216.68 109.58 204.09"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="129.1 193 119.63 209.3 121.97 207.93 129.1 193"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="142.41 185.43 137.02 199.44 138.48 198.56 142.41 185.43"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="52.37 183.31 52.37 195.11 63.1 201.55 63.1 189.75 52.37 183.31"
            fill="#b0376b"
          />
          <polygon
            points="52.84 184.1 52.84 194.88 62.63 200.75 62.63 189.98 52.84 184.1"
            fill="#e2345c"
          />
          <polygon
            points="60.03 188.42 52.84 194.88 54.95 196.15 60.03 188.42"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="61.17 189.1 56.26 196.93 57.78 197.84 61.17 189.1"
            fill="#f4bece"
            opacity="0.52"
          />
          <rect
            x="56.15"
            y="174.93"
            width="84.69"
            height="16.25"
            fill="#24438e"
          />
          <rect
            x="59.83"
            y="176.52"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="114.13"
            y="176.49"
            width="23.02"
            height="12.83"
            fill="#3d356f"
          />
          <rect
            x="86.98"
            y="176.52"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="60.89"
            y="177.11"
            width="20.89"
            height="11.64"
            fill="#cf82bc"
          />
          <rect
            x="88.04"
            y="177.08"
            width="20.89"
            height="11.64"
            fill="#a86c9d"
          />
          <rect
            x="115.2"
            y="177.11"
            width="20.89"
            height="11.64"
            fill="#718fa8"
          />
          <polygon
            points="70.36 177.11 62.09 188.75 63.79 188.75 70.36 177.11"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="126.82 177.11 118.55 188.75 120.25 188.75 126.82 177.11"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="74.36 177.11 65.46 188.72 67.7 188.72 74.36 177.11"
            fill="#f4bece"
          />
          <polygon
            points="131.59 177.13 122.68 188.74 124.93 188.74 131.59 177.13"
            fill="#f4bece"
            opacity="0.51"
          />
          <polygon
            points="98.59 174.94 98.59 191.18 49.45 162.75 49.45 146.5 98.59 174.94"
            fill="#ee93a4"
          />
          <polygon
            points="49.45 146.5 98.59 174.94 147.94 146.5 98.59 118.07 49.45 146.5"
            fill="#d73c58"
          />
          <polygon
            points="98.59 174.94 98.59 191.18 147.94 162.75 147.94 146.5 98.59 174.94"
            fill="#3d356f"
          />
          <polygon
            points="56.35 142.78 141.04 142.78 126.82 94.04 70.57 94.04 56.35 142.78"
            fill="#bc3350"
          />
          <polygon
            points="65.86 190.9 65.86 202.94 79 210.61 79 198.56 65.86 190.9"
            fill="#8a316d"
          />
          <polygon
            points="66.55 191.94 66.55 202.71 78.31 209.57 78.31 198.79 66.55 191.94"
            fill="#b0376b"
          />
          <polygon
            points="81.52 199.78 81.52 211.75 95.67 219.37 95.67 208 81.52 199.78"
            fill="#6d2b5a"
          />
          <polygon
            points="82.22 200.75 82.22 211.53 94.96 218.39 94.96 208.26 82.22 200.75"
            fill="#8a316d"
          />
          <polygon
            points="75.45 197.13 66.9 202.92 69.02 204.15 75.45 197.13"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="92.06 206.56 83.02 211.96 85.24 213.15 92.06 206.56"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="76.9 197.97 70.79 205.19 72.34 206.07 76.9 197.97"
            fill="#f4bece"
            opacity="0.52"
          />
          <g opacity="0.52">
            <path
              d="M86.72,214a45.36,45.36,0,0,1,6.71-6.58A45.39,45.39,0,0,1,86.72,214Z"
              fill="#f4bece"
            />
          </g>
          <polygon
            points="80.81 232.02 80.81 243.99 94.96 251.61 94.96 240.24 80.81 232.02"
            fill="#6d2b5a"
          />
          <polygon
            points="81.52 233 81.52 243.77 94.25 250.63 94.25 240.51 81.52 233"
            fill="#8a316d"
          />
          <polygon
            points="74.75 229.38 66.2 235.16 68.31 236.4 74.75 229.38"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="91.36 238.8 82.32 244.21 84.53 245.4 91.36 238.8"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="76.19 230.22 70.08 237.43 71.63 238.32 76.19 230.22"
            fill="#f4bece"
            opacity="0.52"
          />
          <g opacity="0.52">
            <path
              d="M86,246.2a44.8,44.8,0,0,1,6.71-6.59A46.1,46.1,0,0,1,86,246.2Z"
              fill="#f4bece"
            />
          </g>
          <polygon
            points="52.37 150.81 52.37 162.62 63.1 169.06 63.1 157.25 52.37 150.81"
            fill="#b0376b"
          />
          <polygon
            points="52.84 151.61 52.84 162.38 62.63 168.26 62.63 157.49 52.84 151.61"
            fill="#e2345c"
          />
          <polygon
            points="65.86 158.4 65.86 170.45 79 178.12 79 166.07 65.86 158.4"
            fill="#8a316d"
          />
          <polygon
            points="144.91 150.81 144.91 162.62 134.18 169.06 134.18 157.25 144.91 150.81"
            fill="#6d2b5a"
          />
          <polygon
            points="144.45 151.61 144.45 162.38 134.65 168.26 134.65 157.49 144.45 151.61"
            fill="#8a316d"
          />
          <polygon
            points="131.43 158.4 131.43 170.45 118.28 178.12 118.28 166.07 131.43 158.4"
            fill="#6d2b5a"
          />
          <polygon
            points="130.73 159.44 130.73 170.22 118.98 177.08 118.98 166.3 130.73 159.44"
            fill="#8a316d"
          />
          <polygon
            points="115.77 167.28 115.77 179.25 101.62 186.87 101.62 175.5 115.77 167.28"
            fill="#6d2b5a"
          />
          <polygon
            points="115.06 168.26 115.06 179.03 102.33 185.89 102.33 175.77 115.06 168.26"
            fill="#8a316d"
          />
          <polygon
            points="109.58 171.49 103.49 185.27 105.7 184.08 109.58 171.49"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="129.1 160.4 119.63 176.7 121.97 175.33 129.1 160.4"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="142.41 152.83 137.02 166.84 138.48 165.96 142.41 152.83"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="66.55 159.44 66.55 170.22 78.31 177.08 78.31 166.3 66.55 159.44"
            fill="#b0376b"
          />
          <polygon
            points="81.52 167.28 81.52 179.25 95.67 186.87 95.67 175.5 81.52 167.28"
            fill="#6d2b5a"
          />
          <polygon
            points="82.22 168.26 82.22 179.03 94.96 185.89 94.96 175.77 82.22 168.26"
            fill="#8a316d"
          />
          <polygon
            points="60.03 155.92 52.84 162.38 54.95 163.65 60.03 155.92"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="75.45 164.64 66.9 170.43 69.02 171.66 75.45 164.64"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="92.06 174.06 83.02 179.47 85.24 180.66 92.06 174.06"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="61.17 156.61 56.26 164.43 57.78 165.35 61.17 156.61"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="76.9 165.48 70.79 172.69 72.34 173.58 76.9 165.48"
            fill="#f4bece"
            opacity="0.52"
          />
          <g opacity="0.52">
            <path
              d="M86.72,181.46A43.71,43.71,0,0,1,89.91,178a41.73,41.73,0,0,1,3.52-3.12,41.77,41.77,0,0,1-3.18,3.47A43.71,43.71,0,0,1,86.72,181.46Z"
              fill="#f4bece"
            />
          </g>
          <polygon
            points="49.45 114.35 98.59 142.78 147.94 114.75 98.59 85.92 49.45 114.35"
            fill="#d73c58"
          />
          <polygon
            points="56.15 110.29 140.83 110.29 126.62 61.55 70.36 61.55 56.15 110.29"
            fill="#bc3350"
          />
          <rect
            x="56.35"
            y="142.78"
            width="84.69"
            height="16.25"
            fill="#24438e"
          />
          <rect
            x="60.03"
            y="144.5"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="114.34"
            y="144.48"
            width="23.02"
            height="12.83"
            fill="#3d356f"
          />
          <rect
            x="87.18"
            y="144.5"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="61.09"
            y="145.1"
            width="20.89"
            height="11.64"
            fill="#cf82bc"
          />
          <rect
            x="88.25"
            y="145.07"
            width="20.89"
            height="11.64"
            fill="#a86c9d"
          />
          <rect
            x="115.4"
            y="145.1"
            width="20.89"
            height="11.64"
            fill="#718fa8"
          />
          <polygon
            points="70.56 145.1 62.3 156.74 63.99 156.74 70.56 145.1"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="127.02 145.1 118.76 156.74 120.45 156.74 127.02 145.1"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="74.56 145.1 65.66 156.71 67.91 156.71 74.56 145.1"
            fill="#f4bece"
          />
          <polygon
            points="131.79 145.11 122.89 156.72 125.13 156.72 131.79 145.11"
            fill="#f4bece"
            opacity="0.51"
          />
          <polygon
            points="98.59 142.78 98.59 159.03 49.45 130.59 49.45 114.35 98.59 142.78"
            fill="#ee93a4"
          />
          <polygon
            points="147.94 114.75 147.94 130.59 98.59 159.03 98.59 142.78 147.94 114.75"
            fill="#3d356f"
          />
          <polygon
            points="52.37 118.66 52.37 130.46 63.1 136.9 63.1 125.1 52.37 118.66"
            fill="#b0376b"
          />
          <polygon
            points="52.84 119.45 52.84 130.23 62.63 136.1 62.63 125.33 52.84 119.45"
            fill="#e2345c"
          />
          <polygon
            points="65.86 126.25 65.86 138.3 79 145.96 79 133.91 65.86 126.25"
            fill="#8a316d"
          />
          <polygon
            points="144.91 118.66 144.91 130.46 134.18 136.9 134.18 125.1 144.91 118.66"
            fill="#6d2b5a"
          />
          <polygon
            points="144.45 119.45 144.45 130.23 134.65 136.1 134.65 125.33 144.45 119.45"
            fill="#8a316d"
          />
          <polygon
            points="131.43 126.25 131.43 138.3 118.28 145.96 118.28 133.91 131.43 126.25"
            fill="#6d2b5a"
          />
          <polygon
            points="130.73 127.29 130.73 138.06 118.98 144.92 118.98 134.15 130.73 127.29"
            fill="#8a316d"
          />
          <polygon
            points="115.77 135.13 115.77 147.1 101.62 154.72 101.62 143.35 115.77 135.13"
            fill="#6d2b5a"
          />
          <polygon
            points="115.06 136.1 115.06 146.88 102.33 153.74 102.33 143.62 115.06 136.1"
            fill="#8a316d"
          />
          <polygon
            points="109.58 139.34 103.49 153.11 105.7 151.92 109.58 139.34"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="129.1 128.24 119.63 144.54 121.97 143.17 129.1 128.24"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="142.41 120.67 137.02 134.69 138.48 133.81 142.41 120.67"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="66.55 127.29 66.55 138.06 78.31 144.92 78.31 134.15 66.55 127.29"
            fill="#b0376b"
          />
          <polygon
            points="81.52 135.13 81.52 147.1 95.67 154.72 95.67 143.35 81.52 135.13"
            fill="#6d2b5a"
          />
          <polygon
            points="82.22 136.1 82.22 146.88 94.96 153.74 94.96 143.62 82.22 136.1"
            fill="#8a316d"
          />
          <polygon
            points="60.03 123.77 52.84 130.23 54.95 131.5 60.03 123.77"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="75.45 132.48 66.9 138.27 69.02 139.5 75.45 132.48"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="92.06 141.91 83.02 147.31 85.24 148.5 92.06 141.91"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="61.17 124.45 56.26 132.28 57.78 133.2 61.17 124.45"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="76.9 133.32 70.79 140.54 72.34 141.42 76.9 133.32"
            fill="#f4bece"
            opacity="0.52"
          />
          <g opacity="0.52">
            <path
              d="M86.72,149.3a46.72,46.72,0,0,1,6.71-6.58,40.11,40.11,0,0,1-3.18,3.46A41.86,41.86,0,0,1,86.72,149.3Z"
              fill="#f4bece"
            />
          </g>
          <rect
            x="56.15"
            y="110.29"
            width="84.69"
            height="16.25"
            fill="#24438e"
          />
          <rect
            x="59.48"
            y="112.03"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="113.79"
            y="112"
            width="23.02"
            height="12.83"
            fill="#3d356f"
          />
          <rect
            x="86.64"
            y="112.03"
            width="23.02"
            height="12.83"
            fill="#6d2b5a"
          />
          <rect
            x="60.55"
            y="112.62"
            width="20.89"
            height="11.64"
            fill="#cf82bc"
          />
          <rect
            x="87.7"
            y="112.59"
            width="20.89"
            height="11.64"
            fill="#a86c9d"
          />
          <polygon
            points="98.59 110.29 98.59 126.53 49.45 98.1 49.45 81.85 98.59 110.29"
            fill="#ee93a4"
          />
          <rect
            x="114.85"
            y="112.62"
            width="20.89"
            height="11.64"
            fill="#718fa8"
          />
          <polygon
            points="49.45 81.85 98.59 110.29 147.94 82.26 98.59 53.42 49.45 81.85"
            fill="#c65971"
          />
          <polygon
            points="98.59 110.29 98.59 126.53 147.94 98.1 147.94 81.85 98.59 110.29"
            fill="#3d356f"
          />
          <polygon
            points="50.94 84.94 50.94 96.74 61.67 103.18 61.67 91.37 50.94 84.94"
            fill="#b0376b"
          />
          <polygon
            points="51.4 85.73 51.4 96.51 61.2 102.38 61.2 91.61 51.4 85.73"
            fill="#e2345c"
          />
          <polygon
            points="64.42 92.53 64.42 104.57 77.56 112.24 77.56 100.19 64.42 92.53"
            fill="#8a316d"
          />
          <polygon
            points="65.12 93.57 65.12 104.34 76.87 111.2 76.87 100.42 65.12 93.57"
            fill="#b0376b"
          />
          <polygon
            points="80.08 101.4 80.08 113.38 94.23 120.99 94.23 109.63 80.08 101.4"
            fill="#6d2b5a"
          />
          <polygon
            points="80.79 102.38 80.79 113.16 93.52 120.02 93.52 109.89 80.79 102.38"
            fill="#8a316d"
          />
          <polygon
            points="58.59 90.05 51.4 96.51 53.52 97.78 58.59 90.05"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="74.02 98.76 65.47 104.55 67.58 105.78 74.02 98.76"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="90.63 108.19 81.59 113.59 83.8 114.78 90.63 108.19"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="59.74 90.73 54.82 98.56 56.35 99.47 59.74 90.73"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="75.46 99.6 69.36 106.81 70.9 107.7 75.46 99.6"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="144.71 86.35 144.71 98.16 133.98 104.6 133.98 92.79 144.71 86.35"
            fill="#6d2b5a"
          />
          <polygon
            points="144.24 87.15 144.24 97.92 134.44 103.8 134.44 93.03 144.24 87.15"
            fill="#8a316d"
          />
          <polygon
            points="131.22 93.95 131.22 105.99 118.08 113.66 118.08 101.61 131.22 93.95"
            fill="#6d2b5a"
          />
          <polygon
            points="130.53 94.99 130.53 105.76 118.77 112.62 118.77 101.84 130.53 94.99"
            fill="#8a316d"
          />
          <polygon
            points="115.56 102.82 115.56 114.8 101.41 122.41 101.41 111.05 115.56 102.82"
            fill="#6d2b5a"
          />
          <polygon
            points="114.85 103.8 114.85 114.58 102.12 121.43 102.12 111.31 114.85 103.8"
            fill="#8a316d"
          />
          <polygon
            points="49.45 81.85 98.59 110.29 147.94 81.85 98.59 53.42 49.45 81.85"
            fill="none"
            stroke="#3df9f9"
            strokeMiterlimit="10"
            strokeWidth="0.98"
          />
          <polygon
            points="109.38 107.03 103.28 120.81 105.49 119.62 109.38 107.03"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="128.89 95.94 119.42 112.24 121.77 110.87 128.89 95.94"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="142.21 88.37 136.81 102.38 138.27 101.5 142.21 88.37"
            fill="#71aaa6"
            opacity="0.51"
          />
          <polygon
            points="132.57 110.29 106.33 126.53 98.59 126.53 126.79 110.29 132.57 110.29"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="132.76 207.41 106.51 223.66 98.78 223.66 126.98 207.41 132.76 207.41"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="132.76 142.69 106.51 158.94 98.78 158.94 126.98 142.69 132.76 142.69"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="132.76 174.94 106.51 191.18 98.78 191.18 126.98 174.94 132.76 174.94"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="138.81 103.36 126.79 110.29 132.57 110.29 140.83 110.29 138.81 103.36"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="138.99 135.75 126.79 142.78 132.94 142.78 141.04 142.78 138.99 135.75"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="138.99 167.91 126.79 174.94 132.94 174.94 141.04 174.94 138.99 167.91"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="138.99 200.39 126.79 207.42 132.94 207.42 141.04 207.42 138.99 200.39"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="70.02 112.62 61.75 124.26 63.44 124.26 70.02 112.62"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="126.47 112.62 118.21 124.26 119.9 124.26 126.47 112.62"
            fill="#f4bece"
            opacity="0.52"
          />
          <polygon
            points="74.02 112.62 65.12 124.23 67.36 124.23 74.02 112.62"
            fill="#f4bece"
          />
          <polygon
            points="131.24 112.63 122.34 124.25 124.59 124.25 131.24 112.63"
            fill="#f4bece"
            opacity="0.51"
          />
          <g opacity="0.52">
            <path
              d="M85.29,115.58A44.8,44.8,0,0,1,92,109a43.74,43.74,0,0,1-3.18,3.47A41.86,41.86,0,0,1,85.29,115.58Z"
              fill="#f4bece"
            />
          </g>
          <polygon
            points="94.23 126.53 110.54 135.99 126.72 126.53 94.23 126.53"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="93.66 159.03 109.97 168.49 126.15 159.03 93.66 159.03"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="94.04 191.18 110.35 200.64 126.53 191.18 94.04 191.18"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="93.76 223.81 110.07 233.27 126.24 223.81 93.76 223.81"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="140.83 118.79 147.94 114.75 140.83 110.6 140.83 118.79"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="140.89 150.6 148 146.56 140.89 142.41 140.89 150.6"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="140.83 183.09 147.94 179.06 140.83 174.9 140.83 183.09"
            fill="#3d356f"
            opacity="0.56"
          />
          <polygon
            points="141.04 215.54 147.94 211.49 141.04 207.35 141.04 215.54"
            fill="#3d356f"
            opacity="0.56"
          />
          <polyline
            points="108.94 251.03 151 260 194 224 135.28 221.41 108.94 251.03"
            fill="#321b49"
            opacity="0.56"
          />
        </g>
        <g className="text" transform="translate(81 260)">
          <path
            fill="#fafee7"
            d="M0.8,11.5C0.3,11.4,0,11.2,0,10.7c0-0.3,0-0.7,0-1C0,9.5,0,9.2,0.1,9c0-0.2,0.1-0.4,0.3-0.5
            c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.5,0,0.9,0.1c0.4-1.3,0.9-2.6,1.4-3.9C3.5,3.3,4,2.1,4.5,1C4.7,0.6,5,0.3,5.4,0.2
            c0.3-0.1,0.7-0.1,1.1-0.2S7.2,0,7.5,0C7.7,0,7.8,0,8,0c0.1,0,0.3,0,0.4,0c0.4,0,0.7,0.3,1,0.7c0.4,0.8,0.9,1.9,1.5,3.2
            c0.6,1.3,1.2,2.8,1.7,4.4c0.2,0,0.4,0,0.5,0c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0s0,0,0,0c0.4,0,0.6,0.2,0.7,0.6
            c0.1,0.3,0.1,0.7,0.1,1.2c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0,0.3-0.1,0.5-0.2,0.6c-0.1,0.1-0.3,0.2-0.5,0.2
            c0.1,0.3,0.2,0.6,0.2,0.9c0.1,0.3,0.1,0.5,0.2,0.7c0,0.2,0.1,0.3,0.1,0.3c0,0.1,0,0.1,0,0.1c0,0.3-0.2,0.5-0.5,0.6
            c-0.4,0.1-0.8,0.2-1.2,0.3c-0.4,0.1-0.8,0.1-1.3,0.1c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.3-0.5l-0.6-2.1
            c-0.8,0-1.5,0.1-2.3,0.1c-0.5,0-1,0-1.5,0c-0.5,0-1,0-1.4-0.1c-0.1,0.4-0.2,0.8-0.3,1.1C4.2,13.3,4.1,13.6,4,14
            c-0.1,0.5-0.3,0.7-0.8,0.7c-0.4,0-0.8,0-1.2-0.1c-0.5-0.1-0.9-0.2-1.2-0.3c-0.3-0.1-0.5-0.3-0.5-0.7c0,0,0-0.1,0-0.1
            c0-0.1,0-0.1,0.1-0.3c0-0.2,0.1-0.5,0.2-0.8C0.6,12.1,0.7,11.8,0.8,11.5z M5.4,8.5c0.5,0,1.1,0,1.6,0s1.1,0,1.7,0
            C8.4,7.7,8.2,6.9,7.9,6.1C7.6,5.3,7.3,4.5,6.9,3.8C6.7,4.6,6.4,5.4,6.1,6.2C5.9,7,5.6,7.7,5.4,8.5z"
          />
          <path
            fill="#fafee7"
            d="M15.4,5.6c0-0.3,0-0.6,0.1-0.8c0-0.2,0.2-0.3,0.5-0.4c0.2,0,0.3-0.1,0.6-0.1c0.2,0,0.4-0.1,0.7-0.1
            c0.2,0,0.5,0,0.7,0c0.2,0,0.4,0,0.6,0c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.1,0.4c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3
            c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.3,1.5-0.3c0.4,0,0.6,0.1,0.8,0.4c0.2,0.3,0.3,0.6,0.4,0.9c0.1,0.3,0.1,0.6,0.1,1
            c0,0.4,0,0.7,0,0.9s-0.1,0.5-0.2,0.7C22.6,8.5,22.4,8.7,22,9c-0.2,0.1-0.4,0.2-0.7,0.3c-0.3,0.1-0.5,0.2-0.6,0.2
            c-0.2,0-0.4-0.1-0.5-0.3S20,8.7,20,8.5c0-0.1,0-0.3,0-0.6c0-0.2,0-0.4-0.1-0.6c-0.2,0.1-0.4,0.2-0.5,0.3C19.2,7.7,19,7.8,18.8,8
            c0,0.7,0,1.4,0.1,2c0,0.6,0.1,1.2,0.1,1.7c0,0.5,0.1,0.9,0.1,1.2c0,0.3,0.1,0.5,0.1,0.6c0,0.2-0.1,0.4-0.2,0.5
            c-0.1,0.1-0.4,0.2-0.8,0.2c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0s-0.2,0-0.3,0c-0.4,0-0.7-0.1-0.8-0.3
            c-0.1-0.2-0.2-0.4-0.2-0.7c-0.1-1-0.2-2-0.3-3.1c-0.1-1-0.1-2.1-0.1-3.1c0-0.2,0-0.5,0-0.7S15.3,5.9,15.4,5.6z"
          />
          <path
            fill="#fafee7"
            d="M23.4,6.2c0-0.2,0-0.4,0-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.2,0,0.4-0.1,0.6-0.1V4.6
            c0-0.3,0-0.5,0-0.8c0-0.3,0-0.5,0-0.8c0-0.3,0.1-0.5,0.1-0.6C24.9,2.2,25,2,25.2,1.9c0.2-0.1,0.5-0.2,0.8-0.2
            c0.4-0.1,0.8-0.1,1.4-0.1c0.3,0,0.5,0.1,0.6,0.2c0.1,0.2,0.2,0.4,0.2,0.7c0,0.1,0,0.2,0,0.4c0,0.2,0,0.4,0,0.6c0,0.3,0,0.5,0,0.8
            c0,0.3,0,0.5,0,0.8c0.2,0,0.5,0.1,0.7,0.1c0.2,0,0.5,0.1,0.7,0.1c0.3,0,0.5,0.1,0.6,0.2c0.1,0.1,0.2,0.3,0.2,0.6
            c0,0.1,0,0.3,0,0.5c0,0.2,0,0.4-0.1,0.6c-0.1,0.3-0.1,0.4-0.3,0.5c-0.1,0.1-0.3,0.2-0.6,0.2C29,8,28.8,8,28.6,8s-0.4,0-0.5,0
            c0,0.4,0,0.9,0.1,1.5c0,0.6,0.1,1.1,0.1,1.7c0,0.5,0.1,1,0.1,1.4c0,0.4,0,0.7,0,0.8c0,0.2-0.1,0.4-0.2,0.5
            c-0.1,0.1-0.3,0.2-0.6,0.2c-0.5,0.1-1,0.1-1.5,0.1c-0.3,0-0.4-0.1-0.6-0.2c-0.1-0.1-0.2-0.3-0.2-0.6c-0.1-0.9-0.2-1.9-0.3-2.8
            c-0.1-0.9-0.2-1.9-0.2-2.9l-0.5-0.1c-0.3,0-0.5-0.1-0.6-0.2c-0.1-0.1-0.2-0.3-0.2-0.6c0-0.1,0-0.3,0-0.4
            C23.4,6.5,23.4,6.4,23.4,6.2z"
          />
        </g>
      </g>
      <Checkmarks
        visited={visited}
        process={process}
        position={{ x: 70, y: 148 }}
        gradientIdChunk="art"
      />
    </g>
  );
};

export default Art;
